import * as React from 'react';
import { Button, Icon } from 'antd';
import { Link } from 'react-router-dom';

import { Column, DataTableView } from 'src/core/ui/data-table.view';

interface IEmailDocumentTemplateListViewProps extends ComponentViewProps<DataSet<IEmailDocumentTemplateSummary>> {
	onItemDoubleClicked: (item: IEmailDocumentTemplateSummary) => any;
}

export class EmailDocumentTemplateListView extends React.Component<IEmailDocumentTemplateListViewProps, any> {
	columns: Column[] = [
		{
			title: 'Name',
			key: 'name',
			dataIndex: 'name',
			render: (text, record: IEmailDocumentTemplateSummary) => <Link to={`/general/email-document-templates/${record.id}`}>{text}</Link>,
		},
		{
			title: 'Category',
			key: 'categoryDisplayName',
			dataIndex: 'categoryDisplayName'
		},
		{
			key: 'target',
			title: 'Target',
			dataIndex: 'targetDisplayName'
		}
	];

	constructor(props: IEmailDocumentTemplateListViewProps) {
		super(props);
	}

	render() {
		if (this.props.model == null) {
			return null;
		}

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={this.columns}
						model={this.props.model}
						itemDoubleClick={this.props.onItemDoubleClicked}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/email-document-template/list/email-document-template-list.view.tsx